import React from 'react';
import { connect } from 'react-redux';
import SellerInfo from './SellerInfo';

import {
  getProductsInStore,
  getSellerUsername,
  getIsStoreEnabled,
  getJoinedDate,
} from '../../reducers/ProductReducers';

import {
  getStoreLink,
} from '../../utils/ProductUtils';

const StoreInfoBlock = ({
  productsInStore,
  username,
  isStoreEnabled,
  joinedDate,
}) => (
  <div className="offer-sidebar">
    <SellerInfo refTag="offer_profile"/>
    { joinedDate ?
      <div className="caps soft--top sidebar-content text-grey">{`Joined ${joinedDate}`}</div> :
      null
    }
    { isStoreEnabled ?
      <div className="soft--top sidebar-content">
        <a href={`${getStoreLink(username, 'offer_products')}`} target="_blank">
          <div className="caps">
            {`${productsInStore} ${ productsInStore > 1 ? 'Products' : 'Product' } on Store`}
          </div>
        </a>
        <a href={`${getStoreLink(username, 'offer_page')}`}>
          <div className="btn btn-block push--top sidebar-content">VIEW STORE</div>
        </a>
      </div>
      :
      null
    }
  </div>
);

const mapStateToProps = ({ product }) => ({
  productsInStore: getProductsInStore(product),
  username: getSellerUsername(product),
  isStoreEnabled: getIsStoreEnabled(product),
  joinedDate: getJoinedDate(product),
});

export default connect(mapStateToProps)(StoreInfoBlock);



// WEBPACK FOOTER //
// ./src/product/views/_layout/StoreInfoBlock.js